import {
  PipelineTableDurationCell,
  PipelineTableMetricCell,
} from "src/pages/PipelinesIndexPage/components/PipelinesTable/components/PipelinesTableCells/PipelinesTableCells";
import type { Metrics } from "../../PipelineSummary.types";
import PipelineSummaryMetricsGroup from "./components/PipelineSummaryMetricsGroup/PipelineSummaryMetricsGroup";

interface PipelineSummaryMetricsProps {
  appName: string;
  metrics: Metrics;
}

const PipelineSummaryMetrics = ({
  appName,
  metrics,
}: PipelineSummaryMetricsProps) => {
  const { sla: SLA, duration, ...rest } = metrics;

  const timeMetrics = Object.entries({ SLA, duration }) as [string, Metrics][];
  const restOfMetrics = Object.entries(rest) as [string, Metrics][];

  return (
    <div className="flex gap-12 justify-between">
      <PipelineSummaryMetricsGroup
        appName={appName}
        metrics={restOfMetrics}
        Comp={PipelineTableMetricCell}
      />
      <PipelineSummaryMetricsGroup
        appName={appName}
        metrics={timeMetrics}
        Comp={PipelineTableDurationCell}
      />
    </div>
  );
};

export default PipelineSummaryMetrics;
